import { render, staticRenderFns } from "./ProfilesMatrix.vue?vue&type=template&id=5cf5e985&"
import script from "./ProfilesMatrix.vue?vue&type=script&lang=js&"
export * from "./ProfilesMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesMatrix.vue?vue&type=style&index=0&id=5cf5e985&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports